import { render } from "./PersonalData.vue?vue&type=template&id=5dad9d37&scoped=true"
import script from "./PersonalData.vue?vue&type=script&lang=js"
export * from "./PersonalData.vue?vue&type=script&lang=js"

import "./PersonalData.vue?vue&type=style&index=0&id=5dad9d37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dad9d37"]])

export default __exports__